<div
  class="accordion alert border border-secondary tw-mb-0 tw-mt-[20px] tw-relative"
>
  <span class="accordion__title">
    {{ title }}
  </span>

  <!-- accordion__container -->
  <div
    class="accordion__container accordion__container--collapse tw-leading-normal"
  >
    <ng-content></ng-content>
  </div>

  <!-- accordion__btn -->
  <i
    class="accordion__btn btn-sm btn-light-success mdi mdi-chevron-double-down mdi-22px rounded"
    (click)="onExpandToggle()"
  >
  </i>
</div>
